import Box from '@mui/material/Box'
import format from 'date-fns/format'
import React from 'react'

import { DAY_OF_WEEK_FORMAT_DATE_FNS } from 'settings/constants/date'
import { WEEK_DAYS } from 'settings/constants/day'
import { createDateFromString } from 'utils/date'

import WeekDay from './WeekDay'

import type { WeekDayWorkOrder } from './WeekDay'

type WeekWorkOrder = WeekDayWorkOrder & { serviceDate?: string | null }

type Props = {
  serviceType?: string | null
  workOrders?: WeekWorkOrder[]
}

const WeeklySummaryReadonly: React.FC<Props> = ({ serviceType, workOrders = [] }) => {
  const workOrdersByDayOfWeek = workOrders.reduce<Record<string, WeekWorkOrder[]>>((byDay, workOrder) => {
    const serviceDate = createDateFromString(workOrder.serviceDate)
    if (!serviceDate) return byDay
    const dayOfWeek = format(serviceDate, DAY_OF_WEEK_FORMAT_DATE_FNS)
    return { ...byDay, [dayOfWeek]: [...(byDay[dayOfWeek] ?? []), workOrder] }
  }, {})

  return (
    <Box aria-label={`weekly-summary-${serviceType}`} display="flex" gap={2}>
      {WEEK_DAYS.map(day => (
        <WeekDay key={day} day={day} workOrders={workOrdersByDayOfWeek[day] ?? []} />
      ))}
    </Box>
  )
}

export default WeeklySummaryReadonly
